import { useContext } from "react";
import { RecordContext } from "../../components/record/Record";
import { Groups } from "../../components/groups/Groups";
import { GroupsOptions } from "../../types/groups.types";
import { FormatedFields } from "../../types/fields.types";

type ScheduledTasksGroupsProps = {
	groupsOptions?: GroupsOptions;
};

// Groups wrapper that renders content right below participant_users, regardless of the
// field order and grouping coming from Directus.
export const ScheduledTasksGroups = ({ groupsOptions }: ScheduledTasksGroupsProps) => {
	const context = useContext(RecordContext);
	const formatedFields = context?.formatedFields;

	if (!context || !formatedFields) return null;

	const reorderedFields = moveContentBelowParticipants(formatedFields);

	return (
		<Groups
			item={context.item}
			fields={reorderedFields}
			entityForm={context.entityForm}
			type={context.type}
			groupsOptions={groupsOptions}
		/>
	);
};

const moveContentBelowParticipants = (fields: FormatedFields) => {
	const contentField = fields.find((field) => field.field === "content");
	const participantsField = fields.find((field) => field.field === "participant_users");
	if (!contentField || !participantsField) return fields;

	const movedContentField = {
		...contentField,
		settings: { ...contentField.settings, group: participantsField.settings.group }
	};

	const fieldsWithoutContent = fields.filter((field) => field.field !== "content");
	const participantsIndex = fieldsWithoutContent.indexOf(participantsField);
	const reorderedFields = [
		...fieldsWithoutContent.slice(0, participantsIndex + 1),
		movedContentField,
		...fieldsWithoutContent.slice(participantsIndex + 1)
	];
	return reorderedFields;
};
